import { useState } from "react";
import useReveal from "../../hooks/useReveal";

import { faqQuestions } from "../../data/faqQuestions";

export default function FAQSection({ isDark }) {
	const ref = useReveal(0);
	const [open, setOpen] = useState(0);
	const surface = isDark ? "var(--color-night)" : "var(--color-paper)";
	const ink = isDark ? "var(--color-on-night)" : "var(--color-ink)";
	const muted = isDark ? "var(--color-on-night-muted)" : "var(--color-muted)";
	const rule = isDark ? "var(--color-night-rule)" : "var(--color-rule-2)";

	return (
		<section id="faq" className="py-20 md:py-28" style={{ background: surface }} aria-labelledby="faq-heading">
			<div className="container mx-auto px-4 sm:px-6 max-w-3xl">
				<div ref={ref} className="reveal mb-10">
					<p className="font-display font-bold uppercase mb-3" style={{ fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)", color: "var(--color-accent)" }}>Good to know</p>
					<h2 id="faq-heading" className="font-display font-bold uppercase" style={{ fontSize: "var(--text-display-s)", lineHeight: "var(--lh-tight)", color: ink }}>Questions from the court</h2>
				</div>
				<div style={{ borderTop: `var(--rule-fine) solid ${rule}` }}>
					{faqQuestions.map((item, index) => {
						const isOpen = open === index;
						return <details key={item.question} open={isOpen} style={{ borderBottom: `var(--rule-hair) solid ${rule}` }}>
							<summary onClick={(event) => { event.preventDefault(); setOpen(isOpen ? -1 : index); }} className="w-full flex items-center justify-between gap-6 py-5 text-left cursor-pointer list-none font-display font-bold uppercase" style={{ color: ink, fontSize: "var(--text-xl)" }}>
								{item.question}<span aria-hidden="true" style={{ color: "var(--color-accent)", fontSize: "1.5em", lineHeight: 1 }}>{isOpen ? "−" : "+"}</span>
							</summary>
							<p className="pb-6" style={{ color: muted, lineHeight: "var(--lh-body)", maxWidth: "var(--measure)" }}>{item.answer}</p>
						</details>;
					})}
				</div>
			</div>
		</section>
	);
}
